<template>
  <div>
    <div style="text-align: center">
      <div class="md-layout-item md-small-size-50 md-size-40" style="margin: 0 auto">
        <md-field>
          <label>Blood Group</label>
          <md-select v-model="bloodgroup" name="bloodgroup" id="bloodgroup" @md-selected="selectedBloodgroupDonor(bloodgroup)">
            <md-option v-for="(blood, operator) in bloodGroupList" :key="operator" :value="blood.id">{{blood.blood_group}}</md-option>
          </md-select>
        </md-field>
      </div>
      <br/>
    </div>
    <div v-if="selectBloodGroup">
      <label>
        <div style="display: inline-block; width: 100%; text-align: center; margin-bottom: 2%">
          <gmap-autocomplete
            @place_changed="setPlace" @keydown="addMarker">
          </gmap-autocomplete>
          <!--
                    <md-button style="vertical-align: bottom; background-color: #4689FF !important; text-transform: none; margin-left: 2%" @click="addMarker">Search</md-button>
          -->
        </div>
      </label>
      <br>
      <div style="text-align: center" v-if="placeSearched">
        <md-button style="vertical-align: bottom; background-color: #4689FF !important; text-transform: none; margin-left: 2%" @click="donorResultList">Search</md-button>
      </div>
      <gmap-map
        :center="center"
        :zoom="15"
        style="width:100%;  height: 600px;"
      >
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          @click="center=m.position"
        ></gmap-marker>
      </gmap-map>
    </div>

  </div>
</template>

<script>
  export default {
    name: "GoogleMap",
    data() {
      return {
        // default to Montreal to keep it simple
        // change this to whatever makes sense
        bloodgroup:'',
        selectBloodGroup: false,
        placeSearched: false,
        center: { lat: 45.508, lng: -73.587 },
        markers: [],
        places: [],
        currentPlace: null,
        bloodGroupList: [],
        selectedBloodGroupDonor:[],
        currentGeolocation:{}

      };
    },

    mounted() {
      this.geolocate();
    },

    methods: {
      // receives a place object via the autocomplete component
      setPlace(place) {
        this.currentPlace = place;
      },
      addMarker(e) {
        console.log(e)
        if(e.key === 'Enter'){
          if (this.currentPlace) {
            const marker = {
              lat: this.currentPlace.geometry.location.lat(),
              lng: this.currentPlace.geometry.location.lng()
            };
            console.log(this.currentPlace.geometry.location.lat())
            console.log(this.currentPlace.geometry.location.lng())
            this.markers.push({ position: marker });
            this.places.push(this.currentPlace);
            this.center = marker;
            this.currentPlace = null;
            this.currentGeolocation = marker;
            this.placeSearched = true
          }
        }

      },
      geolocate: function() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });
      },

      selectedBloodgroupDonor (id) {
        console.log(id)
        if(id != "") {
          this.$store.dispatch('GetDonorListAccordingToBloodGroup', id).then((response) => {
            console.log('selectedbloodgroupDonor', response.data.data);
            this.selectedBloodGroupDonor = response.data.data;
            this.selectBloodGroup = true
          })
        }
      },

      donorResultList: function () {

        let PI_RAD = Math.PI / 180.0; // Here PI is 3.141..........
        let donors = this.selectedBloodGroupDonor

        console.log(donors);
        console.log(this.currentGeolocation);

        donors.forEach(donor=>{
          let donor_lat = donor.floating_latitude * PI_RAD;
          let donor_lang = donor.floating_longitude * PI_RAD;

          let user_lat = this.currentGeolocation.lat * PI_RAD;
          let user_lang = this.currentGeolocation.lng * PI_RAD;

          let resultInKM = 6371.01 * Math.acos(Math.sin(donor_lat) * Math.sin(user_lat) + Math.cos(donor_lat) * Math.cos(user_lat) * Math.cos(user_lang - donor_lang));

          if(resultInKM>6){
            donors.pop(donor)
          }
        })

        localStorage.setItem('donor_sorting_list', JSON.stringify(donors))
        this.$emit('switchPanel','DonorSearchResults')
        console.log(donors)

      }
    },

    beforeMount: function () {

      this.$store.dispatch('GetBloodGroup').then((response) => {
        this.bloodGroupList = response.data.data;
        console.log('blood in map',this.bloodGroupList)
      });

    }

  };
</script>
